import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const LockOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function LockOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M18 9V7.5c0-3.31-2.69-6-6-6s-6 2.69-6 6V9H3.5v8.5c0 2.76 2.24 5 5 5h7c2.76 0 5-2.24 5-5V9H18ZM8 7.5c0-2.21 1.79-4 4-4s4 1.79 4 4V9H8V7.5Zm10.5 10c0 1.65-1.35 3-3 3h-7c-1.65 0-3-1.35-3-3V11h13v6.5Z" />
          <path d="M12 17.5c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default LockOutlined;